/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_UnsupportedInputs */

const th_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เบราว์เซอร์นี้ไม่สามารถแสดงการแจ้งเตือนได้`)
};

const en_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This browser cannot show notifications.`)
};

const ja_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このブラウザは通知を表示できません。`)
};

const zh_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此浏览器无法显示通知。`)
};

const es_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este navegador no puede mostrar notificaciones.`)
};

const pt_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este navegador não consegue mostrar notificações.`)
};

const id_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peramban ini tidak bisa menampilkan notifikasi.`)
};

const fr_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce navigateur ne peut pas afficher de notifications.`)
};

const tl_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi kayang magpakita ng notipikasyon ng browser na ito.`)
};

const vi_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trình duyệt này không hiển thị được thông báo.`)
};

const ko_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 브라우저는 알림을 표시할 수 없습니다.`)
};

const de_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Browser kann keine Benachrichtigungen anzeigen.`)
};

const ru_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот браузер не может показывать уведомления.`)
};

const tr_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu tarayıcı bildirim gösteremiyor.`)
};

const it_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo browser non può mostrare notifiche.`)
};

const pl_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta przeglądarka nie może wyświetlać powiadomień.`)
};

const uk_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей браузер не може показувати сповіщення.`)
};

const hi_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह ब्राउज़र सूचनाएँ नहीं दिखा सकता।`)
};

const ar_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذا المتصفح لا يستطيع عرض الإشعارات.`)
};

const ms_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelayar ini tidak boleh memaparkan pemberitahuan.`)
};

const bn_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই ব্রাউজার বিজ্ঞপ্তি দেখাতে পারে না।`)
};

const zh_tw2_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個瀏覽器無法顯示通知。`)
};

const zh_hk2_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個瀏覽器無法顯示通知。`)
};

const ur_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہ براؤزر اطلاعات نہیں دکھا سکتا۔`)
};

const fa_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`این مرورگر نمی‌تواند اعلان نشان دهد.`)
};

const sw_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kivinjari hiki hakiwezi kuonyesha arifa.`)
};

const nl_push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze browser kan geen meldingen tonen.`)
};

/**
* | output |
* | --- |
* | "This browser cannot show notifications." |
*
* @param {Push_UnsupportedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_unsupported = /** @type {((inputs?: Push_UnsupportedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_UnsupportedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_unsupported(inputs)
	if (locale === "ja") return ja_push_unsupported(inputs)
	if (locale === "zh") return zh_push_unsupported(inputs)
	if (locale === "es") return es_push_unsupported(inputs)
	if (locale === "pt") return pt_push_unsupported(inputs)
	if (locale === "id") return id_push_unsupported(inputs)
	if (locale === "fr") return fr_push_unsupported(inputs)
	if (locale === "tl") return tl_push_unsupported(inputs)
	if (locale === "vi") return vi_push_unsupported(inputs)
	if (locale === "ko") return ko_push_unsupported(inputs)
	if (locale === "de") return de_push_unsupported(inputs)
	if (locale === "ru") return ru_push_unsupported(inputs)
	if (locale === "tr") return tr_push_unsupported(inputs)
	if (locale === "it") return it_push_unsupported(inputs)
	if (locale === "pl") return pl_push_unsupported(inputs)
	if (locale === "uk") return uk_push_unsupported(inputs)
	if (locale === "hi") return hi_push_unsupported(inputs)
	if (locale === "ar") return ar_push_unsupported(inputs)
	if (locale === "ms") return ms_push_unsupported(inputs)
	if (locale === "bn") return bn_push_unsupported(inputs)
	if (locale === "zh-TW") return zh_tw2_push_unsupported(inputs)
	if (locale === "zh-HK") return zh_hk2_push_unsupported(inputs)
	if (locale === "ur") return ur_push_unsupported(inputs)
	if (locale === "fa") return fa_push_unsupported(inputs)
	if (locale === "sw") return sw_push_unsupported(inputs)
	if (locale === "nl") return nl_push_unsupported(inputs)
	return en_push_unsupported(inputs)
});